export class FYPeriod {
    id: number = 0;
    u2Date: string|null = null;
    no: string = "";
    fyDesc: string = "";
    beginDate: string|null = null;
    endDate: string|null = null;
    yearEnd: boolean = false;
    year: number = 0;
    fiscalYear: number = 0;
    action: string = "";
    oldBeginDate: string|null = null;
    oldEndDate: string|null = null;
    oldFiscalYear: number = 0;
    editFlag: number = 0;
}
